import React from 'react';
type ProgressBarProps = {
  value: number;
};
export function ProgressBar({
  value
}: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));
  return <div className="fixed top-0 left-0 right-0 h-[3px] bg-white/10 z-50" data-id="element-20">
      <div className="h-full bg-white transition-all duration-500 ease-out" style={{
      width: `${pct}%`
    }} data-id="element-21" />
    </div>;
}